{
  "title": "Kumusta ang aming serbisyo?",
  "lead": "I-rate ang serbisyong ginamit mo. Makatutulong ang iyong sagot para gumanda ang serbisyo ng opisina. Hindi makikilala ang sumagot maliban kung pipiliin mo.",
  "whyTitle": "Bakit kami nagtatanong",
  "whyBody": "Ayon sa Ease of Doing Business Act (RA 11032), sinusukat ng mga tanggapan ng gobyerno kung gaano kasiyahan ang kanilang mga kliyente at kumikilos batay rito. Nakikita ng bawat opisina ang resulta para sa sarili nitong mga serbisyo.",
  "service": "Serbisyong ginamit mo",
  "chooseService": "Pumili ng serbisyo",
  "otherService": "Ibang serbisyo (wala sa listahan)",
  "office": "Opisina",
  "chooseOffice": "Piliin ang opisina",
  "municipalOffices": "Mga opisina ng munisipyo",
  "barangays": "Mga barangay",
  "serviceName": "Anong serbisyo ito?",
  "serviceNameHint": "Halimbawa: \"Barangay clearance\".",
  "ratingsTitle": "Ang iyong rating",
  "q_overall": "Sa kabuuan, gaano ka nasiyahan?",
  "q_ease": "Gaano kadali ang proseso?",
  "q_time": "Makatwiran ba ang tagal ng proseso?",
  "q_courtesy": "Gaano kagalang at matulungin ang mga kawani?",
  "short_overall": "Kabuuan",
  "short_ease": "Dali",
  "short_time": "Tagal",
  "short_courtesy": "Galang",
  "optional": "opsyonal",
  "r1": "Napakasama",
  "r2": "Masama",
  "r3": "Katamtaman",
  "r4": "Maganda",
  "r5": "Napakaganda",
  "clearRating": "Burahin",
  "comment": "Komento o mungkahi",
  "commentHint": "Ano ang naging maayos? Ano ang dapat baguhin?",
  "includeName": "Isama ang aking pangalan ({name}) para malaman ng opisina kung sino ang nagpadala",
  "complaint": "Ituring itong pormal na reklamo",
  "complaintHint": "Kailangang aksyunan ito ng opisina. Makakatanggap ka ng reference number at masusubaybayan mo ito sa Aking mga request.",
  "complaintSignIn": "Para magsampa ng pormal na reklamo, mag-sign in para makasagot ang opisina at masubaybayan mo ito.",
  "complaintComment": "Ilarawan ang nangyari",
  "complaintCommentHint": "Kailan ito nangyari, ano ang hiningi sa iyo, at ano ang inaasahan mo.",
  "chooseServiceError": "Piliin ang serbisyong ginamit mo.",
  "overallError": "Magbigay ng kabuuang rating.",
  "submit": "Ipadala ang puna",
  "submitComplaint": "Ipadala ang reklamo",
  "sending": "Ipinapadala…",
  "thanksTitle": "Salamat!",
  "thanksBody": "Naipadala ang iyong puna sa {office}.",
  "complaintTitle": "Naisampa ang iyong reklamo",
  "complaintBody": "Reference {ref}. May hanggang 7 araw ng trabaho ang opisina para aksyunan ito. Masusubaybayan mo ito sa Aking mga request.",
  "trackComplaint": "Subaybayan ang aking reklamo",
  "another": "Mag-rate ng ibang serbisyo",
  "hotlineTitle": "Hindi pa rin naayos?",
  "hotlineBody": "Puwede ka ring tumawag sa pambansang 8888 Citizens' Complaint Center: tumawag sa 8888 o bisitahin ang 8888.gov.ph.",
  "insightsTitle": "Kasiyahan ng kliyente",
  "insightsLead": "Ang sinasabi ng mga residente tungkol sa mga serbisyo ng opisinang ito. Hindi kilala ang sumagot maliban kung pinili ng residente na isama ang pangalan.",
  "range": "Panahon",
  "range30": "30 araw",
  "range90": "90 araw",
  "range365": "12 buwan",
  "from": "Mula",
  "to": "Hanggang",
  "responses": "Mga sagot",
  "overallAvg": "Kabuuang rating",
  "outOf5": "{value} / 5",
  "complaints": "Mga pormal na reklamo",
  "viewComplaints": "Buksan sa Mga request",
  "averagesTitle": "Average sa bawat tanong",
  "notAnswered": "Walang sagot",
  "distribution": "Paano nag-rate ang mga residente",
  "question": "Tanong",
  "showTable": "Ipakita bilang talahanayan",
  "hideTable": "Ipakita bilang tsart",
  "colRating": "Rating",
  "colCount": "Mga sagot",
  "ratingN": "{n} · {label}",
  "byService": "Ayon sa serbisyo",
  "colService": "Serbisyo",
  "colResponses": "Mga sagot",
  "colOverall": "Kabuuan",
  "latest": "Pinakabagong mga komento",
  "noComment": "Walang komento",
  "anonymous": "Hindi kilala",
  "complaintRef": "Reklamo {ref}",
  "exportCsv": "I-export ang CSV",
  "empty": "Walang puna sa panahong ito",
  "emptyBody": "Hilingin sa mga residente na i-rate ang inyong serbisyo sa app (Iba pa → Puna), halimbawa sa pamamagitan ng karatula sa inyong counter."
}
